{
  "id": "custom-block-transform",
  "defaultLayout": "rotate",
  "colors": {
    "background": "rgba(248,250,246,0.18)",
    "border": "#383e43",
    "buttonBackground": "rgba(255,255,255,0.025)",
    "buttonHoverBackground": "rgba(255,255,255,0.42)",
    "buttonBorder": "#383e43",
    "text": "#ffffff",
    "textHover": "#ffffff",
    "iconFill": "#383e43",
    "iconHoverFill": "#f28c28",
    "iconStroke": "#ffffff",
    "iconHoverStroke": "#ffffff",
    "iconStrokeWidth": 10,
    "iconHoverStrokeWidth": 10,
    "tooltipBackground": "rgba(30,32,34,0.94)",
    "tooltipText": "#ffffff",
    "tooltipBorder": "#ffffff"
  },
  "icons": {
    "arrow": {
      "src": "/assets/face-ui/transform/arrow.svg"
    }
  },
  "layouts": [
    {
      "id": "rotate",
      "hotkey": "KeyR",
      "template": "directional4",
      "buttons": [
        {
          "id": "up",
          "icon": {
            "alias": "arrow",
            "rotation": 0,
            "fallback": "up"
          },
          "tooltip": "Rotate upward"
        },
        {
          "id": "right",
          "icon": {
            "alias": "arrow",
            "rotation": 90,
            "fallback": "right"
          },
          "tooltip": "Rotate right"
        },
        {
          "id": "down",
          "icon": {
            "alias": "arrow",
            "rotation": 180,
            "fallback": "down"
          },
          "tooltip": "Rotate downward"
        },
        {
          "id": "left",
          "icon": {
            "alias": "arrow",
            "rotation": 270,
            "fallback": "left"
          },
          "tooltip": "Rotate left"
        }
      ]
    },
    {
      "id": "mirror",
      "hotkey": "Control",
      "momentary": true,
      "template": "directional4",
      "colors": {
        "buttonHoverBackground": "rgba(255,255,255,0.58)"
      },
      "buttons": [
        {
          "id": "up",
          "icon": {
            "alias": "arrow",
            "rotation": 0,
            "fallback": "up"
          },
          "tooltip": "Mirror upward"
        },
        {
          "id": "right",
          "icon": {
            "alias": "arrow",
            "rotation": 90,
            "fallback": "right"
          },
          "tooltip": "Mirror right"
        },
        {
          "id": "down",
          "icon": {
            "alias": "arrow",
            "rotation": 180,
            "fallback": "down"
          },
          "tooltip": "Mirror downward"
        },
        {
          "id": "left",
          "icon": {
            "alias": "arrow",
            "rotation": 270,
            "fallback": "left"
          },
          "tooltip": "Mirror left"
        }
      ]
    }
  ]
}
